<div id="index-frame" *ngIf="openIdProfile">
    <h2>Transaction summary</h2>

    <table class="table table-sm" *ngIf="summary.length">
        <thead>
            <th>Type</th>
            <th>Sender</th>
            <th>Receiver</th>
        </thead>
        <tbody>
            <tr *ngFor="let sum of summary">
                <td>{{ sum.transaction_type | humancase }}</td>
                <td>
                    {{ sum.sender.amount | currency }} ({{ sum.sender.count }})
                </td>
                <td>
                    {{ sum.receiver.amount | currency }} ({{
                        sum.receiver.count
                    }})
                </td>
            </tr>
        </tbody>
    </table>

    <div class="grid-split-2">
        <div>
            <app-dialog-ledger-payment></app-dialog-ledger-payment>
        </div>
        <div>
            <app-dialog-ledger-request-withdrawal></app-dialog-ledger-request-withdrawal>
        </div>
    </div>
</div>
